import { URLASSOLUTO } from './variables';
import Swal from './sweetalert2';
import axios from 'axios';

document.addEventListener('DOMContentLoaded', function () {

    // MENU MOBILE
    let menuDisplay = document.querySelector("#menu-display");
    if (menuDisplay) {
        menuDisplay.addEventListener("click", (e) => {

            //console.log(document.querySelector('.menuToggle input').checked);
            if (document.querySelector('.menuToggle input').checked === false) return;

            axios.get(URLASSOLUTO + '/menu-mobile/')
                .then(function (response) {
                    // handle success
                    //console.log(response.data);

                    Swal.fire({
                        background: '#fff',
                        position: 'center-end',
                        grow: 'fullscreen',
                        showCloseButton: true,
                        showConfirmButton: false,
                        customClass: {
                            container: 'menu-mobile',
                        },
                        html: response.data,
                        onClose: function () {
                            document.querySelector('.menuToggle input').click();
                        }
                    });

                    let showSubMenu = document.querySelectorAll(".showSubMenu");
                    //console.log(showSubMenu);
                    if (showSubMenu) {
                        showSubMenu.forEach(submenu => {
                            submenu.addEventListener("click", (e) => {
                                submenu.nextElementSibling.querySelector(".subnavMobile").classList.toggle("selected");
                            });
                        });
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .then(function () {
                    // always executed
                });

        });
    }

});
